/*
Poornima 09/19/2022 2701012930 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
Sohel 11/09/2022 2701012930  prepoulate Filter code.
Sohel 12/16/2022 2701012930 map Fields changes
Akhila 05/31/2023 2701012930 unsaved changes bug fixed
*/
import React, {useEffect, useState} from 'react';
import RuleGroupSearch from './RuleGroupSearch';
import {ResetStatus as resetStatus} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch} from 'react-redux';

const SearchRuleGroupContainer = ({
  handleClose,
  dataReset,
  setValue,
  setBreCode,
  setResetData,
  roleDataBre,
  setRoleDataBre,
  setRowData,
  setRowSelected,
  StepperFilter,
  setShowFilterData,
  setIsCopy,
  ruleGroupCode,
  setRuleGroupCode,
  setGroupId,
  setRuleGroupId,
  handleDirty,
}) => {
  const dispatch = useDispatch();

  const [selectedRows, setSelectedRows] = useState([]);
  const [searchData, setSearchData] = useState({});
  useEffect(() => {
    dispatch(resetStatus());
    setBreCode && setBreCode(null);
    setRowData && setRowData(null);
  }, []);

  return (
    <>
      <RuleGroupSearch
        setValue={setValue}
        setRowData={setRowData}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        searchData={searchData}
        setSearchData={setSearchData}
        handleClose={handleClose}
        setBreCode={setBreCode}
        setResetData={setResetData}
        dataReset={dataReset}
        roleDataBre={roleDataBre}
        setRoleDataBre={setRoleDataBre}
        setRowSelected={setRowSelected}
        StepperFilter={StepperFilter}
        setShowFilterData={setShowFilterData}
        setIsCopy={setIsCopy}
        ruleGroupCode={ruleGroupCode}
        setRuleGroupCode={setRuleGroupCode}
        setGroupId={setGroupId}
        setRuleGroupId={setRuleGroupId}
        handleDirty={handleDirty}
      />
    </>
  );
};
export default SearchRuleGroupContainer;
